export default "__VITE_ASSET__CerMmwDX__"